import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconOrSpinner from "../../../../Components/Utils/IconOrSpinner";
import { DeletarConfigEnvelopeController } from "../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IConfigEnvelope } from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeInterfaces";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";

interface IConfigDeEnvelopeDaGestaoProps {
    configEnvelope: IConfigEnvelope;
    onEditClick(): void;
    onDelete(): void;
}

export default function ConfigDeEnvelopeDaGestao(
    props: IConfigDeEnvelopeDaGestaoProps
) {
    const { execute: deletarConfigDeEnvelope, loading: deletando } =
        useAsyncCallback(DeletarConfigEnvelopeController);

    return (
        <div className="rowCapys">
            <div>
                <h4>{props.configEnvelope.DS_ENVELOPE}</h4>
            </div>
            <div className="col-tools">
                <div className="Button-Tools">
                    <button
                        className="btn btn-outline-primary font-weight-bold mr-2"
                        onClick={props.onEditClick}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                    </button>
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        disabled={deletando}
                        onClick={() => {
                            AlertConfirmation(
                                "Deseja apagar essa configuração de envelope?",
                                ""
                            ).then((result) => {
                                if (result.isConfirmed) {
                                    deletarConfigDeEnvelope(
                                        props.configEnvelope
                                            .ID_ENVELOPE_DOCUSIGN_CONFIG
                                    ).then(props.onDelete);
                                }
                            });
                        }}
                    >
                        <IconOrSpinner
                            icon={faTrash}
                            size="lg"
                            loading={deletando}
                            loadingSize={"md"}
                        />{" "}
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    );
}
